import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { addNotif } from "@/lib/notifications";

function chime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext; if (!Ctx) return;
    const ctx = new Ctx(); const t0 = ctx.currentTime;
    [[880, 0], [1174.66, 0.12]].forEach(([f, at]) => { const o = ctx.createOscillator(); const g = ctx.createGain(); o.type = "sine"; o.frequency.value = f; o.connect(g); g.connect(ctx.destination); g.gain.setValueAtTime(0.0001, t0 + at); g.gain.exponentialRampToValueAtTime(0.25, t0 + at + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t0 + at + 0.5); o.start(t0 + at); o.stop(t0 + at + 0.55); });
    setTimeout(() => ctx.close().catch(() => {}), 1200);
  } catch { /* silent */ }
}

// App-wide wholesale notifications: supplier ⇄ buyer order status changes (new, seen, preparing, ready, collected, rejected, cancelled, edited, discount)
export function WholesaleAlerts() {
  const { staff, loaded, online, view, t } = useApp();
  const nav = useNavigate();
  const seen = useRef(new Set());
  const isSupplier = view.shop?.type === "wholesale";
  useEffect(() => {
    if (!staff || !loaded) return;
    let alive = true;
    const poll = async () => {
      if (!online) return;
      try {
        const r = await api.get("/wholesale/notices");
        if (!alive) return;
        const fresh = (r.data.notices || []).filter((x) => !seen.current.has(x.id));
        fresh.forEach((x) => { seen.current.add(x.id); addNotif("wholesale", x.text, { key: `ws:${x.id}`, to: isSupplier ? "/supplier-hub" : "/wholesale" }); });
        if (fresh.length) chime();
        fresh.forEach((x) => toast.info(x.text, { duration: 12000, action: { label: t("ws_title"), onClick: () => nav(isSupplier ? "/supplier-hub" : "/wholesale") } }));
      } catch { /* offline or not wholesale-enabled */ }
    };
    poll();
    const id = setInterval(poll, 20000);
    return () => { alive = false; clearInterval(id); };
  }, [staff, loaded, online, isSupplier, nav, t]);
  return null;
}
